import StylePanelFlyout from './StylePanelFlyout';

export default StylePanelFlyout;